/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

export const CREATE_CALENDAR_REQUEST = "CREATE_CALENDAR_REQUEST";
export const CREATE_CALENDAR_SUCCESS = "CREATE_CALENDAR_SUCCESS";
export const CREATE_CALENDAR_FAILURE = "CREATE_CALENDAR_FAILURE";

export const UPDATE_CALENDAR_REQUEST = "UPDATE_CALENDAR_REQUEST";
export const UPDATE_CALENDAR_SUCCESS = "UPDATE_CALENDAR_SUCCESS";
export const UPDATE_CALENDAR_FAILURE = "UPDATE_CALENDAR_FAILURE";

export const DELETE_CALENDAR_REQUEST = "DELETE_CALENDAR_REQUEST";
export const DELETE_CALENDAR_SUCCESS = "DELETE_CALENDAR_SUCCESS";
export const DELETE_CALENDAR_FAILURE = "DELETE_CALENDAR_FAILURE";

export const GET_CALENDARS_REQUEST = "GET_CALENDARS_REQUEST";
export const GET_CALENDARS_SUCCESS = "GET_CALENDARS_SUCCESS";
export const GET_CALENDARS_FAILURE = "GET_CALENDARS_FAILURE";

export const GET_CALENDARS_FOR_HOME_REQUEST = "GET_CALENDARS_FOR_HOME_REQUEST";
export const GET_CALENDARS_FOR_HOME_SUCCESS = "GET_CALENDARS_FOR_HOME_SUCCESS";
export const GET_CALENDARS_FOR_HOME_FAILURE = "GET_CALENDARS_FOR_HOME_FAILURE";
